import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis ml-4 mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_resource_picker = _resolveComponent("resource-picker")!
  const _component_languages_edit_dialog = _resolveComponent("languages-edit-dialog")!
  const _component_thumbnail_picker_field = _resolveComponent("thumbnail-picker-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_autocomplete_multiple = _resolveComponent("autocomplete-multiple")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createCommentVNode(" dialog z edycją wybranego elementu "),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.editDialog,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editDialog) = $event)),
        persistent: "",
        scrollable: "",
        "max-width": "1200px"
      }, {
        default: _withCtx(() => [
          (_ctx.editedItem)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                id: "edit-form",
                name: "editForm",
                role: "form",
                onSubmit: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.updateEditedItem()), ["prevent"]))
              }, [
                _createVNode(_component_v_card, { height: "85vh" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { color: "surface-variant" }, {
                      default: _withCtx(() => [
                        (_ctx.editedItem.menuId.id)
                          ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('admin-menus.edit.title')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        (!_ctx.editedItem.menuId.id)
                          ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('admin-menus.edit.create')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          icon: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeEditItemDialog(false)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode("mdi-close", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    (!_ctx.isRootMenu)
                                      ? (_openBlock(), _createBlock(_component_v_select, {
                                          key: 0,
                                          modelValue: _ctx.editedItem.actionType,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editedItem.actionType) = $event)),
                                          items: _ctx.availableMenuActionTypeOptions,
                                          label: _ctx.$t('admin-menus.edit.actionType')
                                        }, null, 8 /* PROPS */, ["modelValue", "items", "label"]))
                                      : _createCommentVNode("v-if", true),
                                    (_ctx.editedItem.actionType == 'MENU_RESOURCE')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                          _createVNode(_component_v_text_field, {
                                            "model-value": _ctx.selectedResource ? _ctx.selectedResource.name : _ctx.editedItem.resourceId?.uuid,
                                            readonly: "",
                                            clearable: "",
                                            label: _ctx.$t('admin-menus.edit.resource'),
                                            "hide-details": "auto",
                                            "onClick:clear": _ctx.clearResource
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                icon: "",
                                                variant: "text",
                                                onClick: _ctx.chooseResource
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, null, {
                                                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                      _createTextVNode("mdi-database-search", -1 /* CACHED */)
                                                    ]))]),
                                                    _: 1 /* STABLE */
                                                  })
                                                ]),
                                                _: 1 /* STABLE */
                                              }, 8 /* PROPS */, ["onClick"])
                                            ]),
                                            _: 1 /* STABLE */
                                          }, 8 /* PROPS */, ["model-value", "label", "onClick:clear"]),
                                          (_ctx.selectedResource)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.selectedResource.uuid), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true),
                                          _createVNode(_component_resource_picker, { ref: "resourcePicker" }, null, 512 /* NEED_PATCH */)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _ctx.v$.editedItem.name.$model,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.editedItem.name.$model) = $event)),
                                      clearable: "",
                                      label: _ctx.$t('admin-menus.edit.name'),
                                      "error-messages": _ctx.editedItemNameErrors
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_languages_edit_dialog, {
                                          translations: _ctx.editedItem.translations,
                                          "onUpdate:translations": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editedItem.translations) = $event)),
                                          title: _ctx.$t('component-languages.edit.langs'),
                                          "icon-only": ""
                                        }, null, 8 /* PROPS */, ["translations", "title"])
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "label", "error-messages"]),
                                    _createVNode(_component_thumbnail_picker_field, {
                                      "model-value": _ctx.editedItem.thumbnail?.uuid,
                                      label: _ctx.$t('admin-menus.edit.thumbnail'),
                                      "error-messages": _ctx.editedItemThumbnailErrors,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = val => _ctx.editedItem.thumbnail = { uuid: val ?? '' })
                                    }, null, 8 /* PROPS */, ["model-value", "label", "error-messages"]),
                                    (!_ctx.isRootMenu && _ctx.editedItem.actionType !== 'MENU_RESOURCE')
                                      ? (_openBlock(), _createBlock(_component_v_select, {
                                          key: 2,
                                          class: "mt-4",
                                          modelValue: _ctx.editedItem.contentLayout,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editedItem.contentLayout) = $event)),
                                          items: _ctx.availableMenuContentLayoutOptions,
                                          label: _ctx.$t('admin-menus.edit.contentLayout')
                                        }, null, 8 /* PROPS */, ["modelValue", "items", "label"]))
                                      : _createCommentVNode("v-if", true),
                                    _createVNode(_component_v_text_field, {
                                      class: "mt-4",
                                      modelValue: _ctx.editedItem.sortNo,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editedItem.sortNo) = $event)),
                                      clearable: "",
                                      label: _ctx.$t('admin-menus.edit.sortNo')
                                    }, null, 8 /* PROPS */, ["modelValue", "label"]),
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: _ctx.editedItem.active,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editedItem.active) = $event)),
                                      label: _ctx.$t('admin-menus.edit.active')
                                    }, null, 8 /* PROPS */, ["modelValue", "label"]),
                                    (_ctx.isRootMenu)
                                      ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                          key: 3,
                                          modelValue: _ctx.editedItem.publicDefault,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editedItem.publicDefault) = $event)),
                                          label: _ctx.$t('admin-menus.edit.publicDefault')
                                        }, null, 8 /* PROPS */, ["modelValue", "label"]))
                                      : _createCommentVNode("v-if", true),
                                    (_ctx.editedItem.actionType == 'FILTER')
                                      ? (_openBlock(), _createBlock(_component_autocomplete_multiple, {
                                          key: 4,
                                          items: _ctx.allMenuFilters,
                                          "item-value": "filterId.id",
                                          "item-title": "filterName",
                                          modelValue: _ctx.selectedMenuFilterIds,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedMenuFilterIds) = $event)),
                                          label: _ctx.$t('admin-menus.edit.filters')
                                        }, null, 8 /* PROPS */, ["items", "modelValue", "label"]))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          variant: "outlined",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeEditItemDialog(false)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('admin-menus.edit.cancel')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_btn, {
                          variant: "flat",
                          color: "primary",
                          type: "submit",
                          disabled: _ctx.v$.$invalid
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('admin-menus.edit.save')), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled"])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ], 32 /* NEED_HYDRATION */))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ]),
    _: 1 /* STABLE */
  }))
}